import * as yup from 'yup';
import { TFunction } from 'i18next';

const validPhoneNumber = /^(?=.{7,17}$)[+]{0,1}[0-9() .-]{1,}$/;

export interface GuardianValidationOptions {
    t: TFunction;
    guardianEmail?: string;
    accountEmail?: string;
    emailExisted?: boolean | null;
}

export const createGuardianValidationSchema = (options: GuardianValidationOptions) => {
    const { t, guardianEmail, emailExisted, accountEmail } = options;

    return yup.object({
        guardianFirstName: yup
            .string()
            .max(
                50,
                t('errors.epic.validation.maxLength.v2', {
                    field: t('epic.esport.label.profile.guardian.firstName'),
                    maxLength: 50
                })
            )
            .required(t('errors.epic.validation.required')),
        guardianLastName: yup
            .string()
            .max(
                50,
                t('errors.epic.validation.maxLength.v2', {
                    field: t('epic.esport.label.profile.guardian.lastName'),
                    maxLength: 50
                })
            )
            .required(t('errors.epic.validation.required')),
        guardianEmail: yup
            .string()
            .email(t('errors.epic.validation.email'))
            .test('conditional-required', t('errors.epic.validation.required'), (value) => {
                if (guardianEmail && !emailExisted) {
                    return true;
                }
                return !!value;
            })
            .test('email-existed', '', function (value) {
                if (emailExisted === true && value === guardianEmail) {
                    return this.createError({
                        message: t('epic.esport.guardianInfo.emailExisted', {
                            email: guardianEmail
                        })
                    });
                }
                if (emailExisted === true && value === accountEmail) {
                    return this.createError({
                        message: t('errors.com.epicgames.ecommerce.payout.payoutaccount.diff', {
                            email: accountEmail
                        })
                    });
                }
                return true;
            }),
        guardianPhoneNumber: yup
            .string()
            .matches(
                validPhoneNumber,
                t('errors.epic.validation.valied.v2', {
                    field: t('epic.esport.label.profile.guardian.phone.v2')
                })
            )
            .required(t('errors.epic.validation.required'))
    });
};

export const createSimpleGuardianValidationSchema = (options: GuardianValidationOptions) => {
    const { t, accountEmail } = options;
    return yup.object({
        guardianFirstName: yup
            .string()
            .max(
                50,
                t('errors.epic.validation.maxLength.v2', {
                    field: t('epic.esport.label.profile.guardian.firstName'),
                    maxLength: 50
                })
            )
            .required(t('errors.epic.validation.required')),
        guardianLastName: yup
            .string()
            .max(
                50,
                t('errors.epic.validation.maxLength.v2', {
                    field: t('epic.esport.label.profile.guardian.lastName'),
                    maxLength: 50
                })
            )
            .required(t('errors.epic.validation.required')),
        guardianEmail: yup
            .string()
            .email(t('errors.epic.validation.email'))
            .required(t('errors.epic.validation.required'))
            .test('email-existed', '', function (value) {
                if (value === accountEmail) {
                    return this.createError({
                        message: t('errors.com.epicgames.ecommerce.payout.payoutaccount.diff', {
                            email: accountEmail
                        })
                    });
                }
                return true;
            }),
        guardianPhoneNumber: yup
            .string()
            .matches(
                validPhoneNumber,
                t('errors.epic.validation.valied.v2', {
                    field: t('epic.esport.label.profile.guardian.phone.v2')
                })
            )
            .required(t('errors.epic.validation.required'))
    });
};
